import { compose, withHandlers, withState } from 'recompose';
import { withAxios } from 'op/components/auth';
import { withOnlineStatus } from 'op/components/offline';
import { withErrorHandling } from 'op/components/error';

export const withAuditList = compose(
	withAxios,
	withErrorHandling,
	withOnlineStatus,
	withState('loading', 'setLoading', 'full'),
	withState('audits', 'setAudits', []),
	withHandlers({
		fetchAudits: function (props) {
			var setLoading = props.setLoading;
			var setAudits = props.setAudits;
			var axios = props.axios;
			var throwError = props.throwError;

			return async function () {
				setLoading('partial');
				try {
					var response = await axios.get('/api/Audit/getMainAudits', {
						clearCacheEntry: true
					});
					setAudits(response.data);
				} catch (e) {
					throwError({
						message: 'Unable to Fetch Audits',
						details: e.message + '; ' + e.stack,
					});
				}
				setLoading(false);
			};
		}
	}),
	// lifecycle({
	// 	componentDidMount: function() {
	// 		if (this.props.online) {
	// 			this.props.fetchAudits();
	// 		} else {
	// 			this.props.setLoading(false);
	// 		}
	// 	}
	// }),
);
